import { CutsProjectModel } from './custProject.model';

export class MasterClientModel {
    QueryValue: string;
    CustAccount: string;
    CustName: string;
    CreditMaxColon: string;
    CreditMaxDolar: string;
    CustGroup: string;
    MandatoryCreditLimit: number;
    CXCAuthorizationReq: number;
    SalesDistrict: string;
    PaymTerm: string;
    TaxGroup: string;
    Currency: string;
    DlvMode: string;
    SiteId: string;
    SiteName: string;
    StatisticsGroup: string;
    Project: string;
    ExtralumEmail: string;
    Active: number;
    CreatedBy: string;
    Company: string;
    Action: string;
    ProjectList: CutsProjectModel[];
    Identification: string;

    constructor() {
        this.QueryValue = '';
        this.CustAccount = '';
        this.CustName = '';
        this.CreditMaxColon = '';
        this.CreditMaxDolar = '';
        this.CustGroup = '';
        this.MandatoryCreditLimit = 0;
        this.CXCAuthorizationReq = 0;
        this.SalesDistrict = '';
        this.PaymTerm = '';
        this.TaxGroup = '';
        this.Currency = '';
        this.DlvMode = '';
        this.SiteId = '';
        this.SiteName = '';
        this.StatisticsGroup = '';
        this.Project = '';
        this.ExtralumEmail = '';
        this.Active = 0;
        this.CreatedBy = '';
        this.Company = '';
        this.Action = '';
        this.ProjectList = [];
        this.Identification = '';

    }
}
